import React, { createContext, useContext, useReducer, useRef } from 'react';
import type { State } from './types';
import { type Computed, useComputed } from './computed';
import { reducer, type Mutation } from './mutations';

export interface UsersStore {
  loaded: React.MutableRefObject<boolean>;
  state: State;
  computed: Computed;
  dispatch: React.Dispatch<Mutation>;
}

const UsersContext = createContext<UsersStore>({} as UsersStore);

export function UsersStoreProvider({
  children,
}: {
  children: React.ReactElement;
}) {
  const initialState: State = {
    users: {},
    loaded: false,
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const computed = useComputed(state);
  const loaded = useRef<boolean>(false);
  const props: UsersStore = {
    loaded,
    state,
    dispatch,
    computed,
  };

  return React.createElement(UsersContext.Provider, { value: props }, children);
}

export function useUsersStore() {
  return useContext(UsersContext);
}
